<template>
  <div>
    <b-navbar
      toggleable="lg"
      class="px-2"
      type="light"
      variant="light"
      style="webkit-box-shadow: 0 1px 15px rgba(0,0,0,.04), 0 1px 6px rgba(0,0,0,.04);
    box-shadow: 0 1px 15px rgba(0,0,0,.04), 0 1px 6px rgba(0,0,0,.04); z-index: 999; max-height: 50px"
    >
      <b-navbar-brand
        style="font-size: 1.1rem"
        role="button"
        @click="goToHomePage"
      >
        Parceiro CAIXA</b-navbar-brand
      >

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!--
            <b-navbar-nav>
                <b-nav-item href="#">Link</b-nav-item>
                <b-nav-item href="#" disabled>Disabled</b-nav-item>
            </b-navbar-nav>
            -->

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto transparent">
          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template v-slot:button-content>
              <i class="fas fa-cog"></i>
            </template>

            <div class=" text-center d-flex justify-content-center my-2">
              <div class="col">
                <!--<img src="http://placehold.it/60x60" class="rounded-circle" />-->
                <avatar :fullname="`${user.name}`"></avatar>
                <h6 class="text-capitalize mt-2" style="font-size: 16px;"></h6>
                <small>{{ user.email }}</small>
              </div>
            </div>
            <hr />
            <b-dropdown-item
              v-if="user.email == `contato@parceirocaixa.com.br`"
              :to="{ name: 'proposals' }"
              >Propostas <i class="far fa-folder-open"></i
            ></b-dropdown-item>
            <b-dropdown-item v-if="user.email == `contato@parceirocaixa.com.br`"
              >Engenharias <i class="fas fa-home"></i
            ></b-dropdown-item>
            <b-dropdown-item
              v-if="user.email == `contato@parceirocaixa.com.br`"
              :to="{ name: 'fgtsDemand' }"
            >
              FGTS <i class="fas fa-hand-holding-usd"></i>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="user.email == `contato@parceirocaixa.com.br`"
              :to="{ name: 'team' }"
              >Usuários <i class="fas fa-users"></i>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="user.email == `contato@parceirocaixa.com.br`"
              :to="{ name: 'ChecklistManager' }"
              >Checklist <i class="fas fa-tasks"></i>
            </b-dropdown-item>
            <b-dropdown-item @click="logOut"
              >Sair <i class="fas fa-sign-out-alt"></i
            ></b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import Avatar from "vue-avatar-component";

export default {
  name: "NavBar",
  data() {
    return {
      searchData: "",
      //uid: this.user.params.uid
    };
  },
  components: { Avatar },
  computed: {
    // ...mapGetters(['proposalFilterOfSearch']),
    ...mapState(["user"]),
  },
  methods: {
    ...mapActions(["logOut", "searchFieldAction", "setProposalOpen"]),
    async goToHomePage() {
      let route = this.$route;
      if (route.name === "editProposal") {
        await this.setProposalOpen({ id: route.params.id, val: false });
        this.$router.push("/");
      }
    },
  },
};
</script>

<style>
a.dropdown-toggle::after {
  display: none;
}
a.dropdown-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
